import { GtmService } from 'tradera/services/google-tagmanager/google-tagmanager-service';
import { HOVER_MENUS } from './hover-menu/constants';
import { selectPreferredLanguageCode } from 'tradera/state/language/selectors';
import {
    selectShowLocalizationRegionPicker,
    selectShowRegionSelection
} from 'tradera/state/shipping-region/selectors';
import HoverMenu from './hover-menu/hover-menu';
import hoverMenuStyles from './hover-menu/hover-menu.module.scss';
import { LocalizationMenu } from 'tradera/components/localization/localization-menu';
import TranslateIcon from '@tradera/blueprint/theme/icons2/translate.svg?jsx';
import { getCountryCodeForFlagFromLanguage } from 'tradera/localization/languagecode';
import Flag from 'tradera/components/flag/flag';
import { useTranslator } from 'tradera/lang/translate';
import { classNames } from 'tradera/utils/class-names';
import { useAppSelector } from 'tradera/state/hooks';

import styles from './localization-link.module.scss';

type LocalizationLinkProps = {
    onClick: (e: React.MouseEvent, menu: string) => void;
    mouseOver: (menu: string) => void;
    mouseOut: () => void;
    showMenu: boolean;
    hideRegionSelection?: boolean;
    showIconAndTextInsteadOfFlag?: boolean;
};

export const LocalizationLink = ({
    onClick,
    mouseOver,
    mouseOut,
    hideRegionSelection,
    showMenu,
    showIconAndTextInsteadOfFlag = false
}: LocalizationLinkProps) => {
    const { t } = useTranslator();

    const preferredLanguageCode = useAppSelector(selectPreferredLanguageCode);
    const showRegionSelectionAppState = useAppSelector(
        selectShowRegionSelection
    );
    const showRegionSelection =
        !hideRegionSelection && showRegionSelectionAppState;
    const showLocalizationRegionPicker = useAppSelector(
        selectShowLocalizationRegionPicker
    );

    const countryCode = getCountryCodeForFlagFromLanguage(
        preferredLanguageCode
    );

    return (
        <div
            className={classNames(
                'tooltip_container position-static tooltip-toggle tooltip-toggle-show',
                showLocalizationRegionPicker && 'tooltip-toggle-show'
            )}>
            <div
                onMouseEnter={() => mouseOver(HOVER_MENUS.LOCALIZATION)}
                onMouseLeave={mouseOut}>
                <button
                    className={classNames(
                        'btn btn-auto slim-header__button slim-header__link-spacing d-flex align-items-center',
                        showMenu && 'active'
                    )}
                    onClick={(e) => {
                        GtmService.trackAction(
                            'Top navigation',
                            'Localization menu',
                            'Open/Close'
                        );
                        onClick(e, HOVER_MENUS.LOCALIZATION);
                    }}>
                    {showIconAndTextInsteadOfFlag ? (
                        <span
                            data-testid="localization-link"
                            className="slim-header__link-text text-nowrap">
                            <TranslateIcon className="icon icon-before" />
                            {t('siteHeader_localizationLink_language')}
                        </span>
                    ) : (
                        <span
                            data-testid="localization-link"
                            className="slim-header__link-text">
                            <Flag
                                className={classNames(styles.flag)}
                                countryCodeIso2={countryCode}
                            />
                        </span>
                    )}
                </button>
                <HoverMenu
                    showMenu={showMenu}
                    className={hoverMenuStyles.alignRight}>
                    <LocalizationMenu
                        showRegionSelection={showRegionSelection || false}
                    />
                </HoverMenu>
            </div>
        </div>
    );
};
